import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { PriceRuleGroupReferenceModel } from "../../models/reference-model/reference-pricing-model";

@Injectable({
    providedIn: 'root'
})
export class PriceRuleGroupReferenceService extends ApiServiceBase {
    private readonly REFERENCE_PATH = '/system/PriceRuleGroupReferences'
    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getPriceRuleGroupReferences(): Observable<PriceRuleGroupReferenceModel[]> {
        return this.httpGet<PriceRuleGroupReferenceModel[]>(this.REFERENCE_PATH, null)
            .pipe(
                map(
                    res => res.body
                )
            )
    }
}